import { useQuery } from "@tanstack/react-query";
import { USER_API } from "config";
import { useAxios } from "hooks/useAxios";
import { referralKeys } from "queries";
import type { ReferralCodeResponse } from "types/referral";
import { useReferralShareActions } from "hooks/referral/useReferralShareActions";

type UseReferralInviteDialogDataOptions = {
  /** When false, the referral code is not fetched (dialog closed). */
  enabled: boolean;
};

export function useReferralInviteDialogData({ enabled }: UseReferralInviteDialogDataOptions) {
  const axios = useAxios();

  const codeQuery = useQuery({
    queryKey: referralKeys.code(),
    queryFn: async () => {
      const res = (await axios.get(USER_API.referralsCode)) as { data: ReferralCodeResponse };
      return res.data;
    },
    enabled,
    retry: 1,
    staleTime: 30_000,
  });

  const shareUrl = codeQuery.data?.share_url ?? "";
  const code = codeQuery.data?.code ?? "";

  const share = useReferralShareActions(shareUrl, code);

  return { codeQuery, shareUrl, code, share };
}
